module.exports = __webpack_public_path__ + "static/img/icon-floor-item-3.dbd5f341.png";